export default __webpack_public_path__ + "static/media/Align-Content.397b0c3a.jpeg";